<template>
  <div style="display: inline-block;" v-if="!isMakePermanent && !isExtend">
    <!-- void for not Being Implemented -->
    <template v-if="!isAvailableToImplement && !isChangeFullInPlace">
      <v-dialog v-model="closedVoidReasonDialog" persistent max-width="600px">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn dark v-bind="activatorProps" color="error" class="ma-2">{{ $t('Void') }}</v-btn>
        </template>
        <v-card>
          <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
          <v-card-text class="text-h6 font-weight-bold">{{ $t('Reason_For_Void') }}</v-card-text>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-form ref="closedVoidMo" v-model="valid" autocomplete="off">
                    <v-textarea
                      v-model="closedVoidReason"
                      name="closedVoidReason"
                      variant="underlined"
                      :rules="closedVoidReasonRules"
                      auto-grow
                    ></v-textarea>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              text
              class="card-button"
              @click="
                closedVoidReason = '';
                closedVoidReasonDialog = false
              "
              >{{ $t('Cancel') }}</v-btn
            >
            <v-btn class="card-button" color="error" text @click="submitVoid()" :disabled="!valid">{{ $t('Save_Void') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Void for Being Implemented -->
    <template v-if="isAvailableToImplement && roleCanVoidAvailableToImplement">
      <v-dialog v-model="closedVoidReasonDialog" persistent max-width="600px">
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn dark v-bind="activatorProps" color="error" class="ma-2">{{ $t('Void') }}</v-btn>
        </template>
        <v-card>
          <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
          <v-card-text class="text-h6 font-weight-bold">{{ $t('Void_Reason') }}</v-card-text>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-form ref="closedVoidMo" v-model="valid" autocomplete="off">
                    <v-textarea
                      v-model="closedVoidReason"
                      name="closedVoidReason"
                      :rules="closedVoidReasonRules"
                      auto-grow
                      variant="underlined"
                    ></v-textarea>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="info"
              text
              class="card-button"
              @click="
                closedVoidReason = '';
                closedVoidReasonDialog = false
              "
              >{{ $t('Cancel') }}</v-btn
            >
            <!-- inner dialog -->
            <v-dialog v-model="closedVoidUndoDialog" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn class="card-button" :disabled="!valid" color="primary" text v-bind="activatorProps">{{ $t('Void') }}</v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                <v-card-text class="text-h5">
                  {{ $t('Prompt_VoidProcess') }}
                </v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-form ref="closedVoidUndoMo" v-model="valid" autocomplete="off">
                        <v-textarea
                          v-model="closedVoidUndo"
                          name="closedVoidUndo"
                          :rules="closedVoidUndoRules"
                          auto-grow
                          variant="underlined"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="error"
                    text
                    class="card-button"
                    @click="
                      closedVoidReason = '';
                      closedVoidUndo = '';
                      closedVoidReasonDialog = false
                    "
                    >{{ $t('Cancel') }}</v-btn
                  >
                  <v-btn class="card-button" color="primary" text @click="submitClosedVoidUndo()">{{ $t('Void') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- /inner dialog -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { AdvanceType } from '@/common/systemTypes'
import MOCService from '@/services/moc.service'
import { FormStatus, Roles } from '@/common'
import { Flags } from '@/common/flags'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
export default {
  name: 'Void',
  data: () => ({
    valid: false,
    isSaving: false,
    closedVoidReasonDialog: false,
    closedVoidReason: '',
    closedVoidUndoDialog: false,
    closedVoidUndo: ''
  }),
  props: {
    role: {
      type: String
    },
    moc: {
      type: Object
    }
  },
  components: {
    Toaster,
    LoadingDialog
  },
  computed: {
    isMakePermanent() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.MAKEPERMANENT].key)
    },
    closedVoidReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required'), v => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    closedVoidUndoRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required'), v => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    isAvailableFormDecision: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value
    },
    isAvailableToImplement: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value
    },
    isChangeFullInPlace: function() {
      return (
        this.moc.status.value === FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value ||
        this.moc.status.value === FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value
      )
    },
    roleCanVoidAvailableToImplement: function() {
      return this.role === Roles.OWNER || this.role === Roles.COORDINATOR || this.role === Roles.FACILITATOR
    },
    isExtend: function() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.EXTEND].key)
    }
  },
  methods: {
    submitVoid: function() {
      if (!this.isSaving) {
        this.isSaving = true
        if (this.$refs.closedVoidMo.validate()) {
          if (this.role === Roles.OWNER) {
            if (!this.moc.ownerDecision) {
              this.moc.ownerDecision = {}
            }
            if (!this.isAvailableFormDecision) {
              this.moc.ownerDecision.decision = { key: 'rejected', value: 'Rejected' }
              this.moc.ownerDecision.reason = this.closedVoidReason
            }
          }
          this.moc.closedVoidedReason = { reason: this.closedVoidReason }
          const data = this.moc

          this.$refs.loadingDialog.show()
          MOCService.save(data, AdvanceType.CLOSEVOID)
            .then(result => {
              if (!result.success) {
                throw new Error(result.message)
              }
              this.closedVoidReasonDialog = false
              this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_ClosedVoidSaved') })
            })
            .catch(e => {
              this.$refs.loadingDialog.error({ metadata: 'submitVoid', error: e, message: this.$t('Error_CloseVoid') })
            })
            .finally(() => {
              this.isSaving = false
            })
        }
      }
    },
    submitClosedVoidUndo: function() {
      if (!this.isSaving) {
        this.isSaving = true
        if (this.$refs.closedVoidUndoMo.validate()) {
          this.moc.closedVoidedReason = { reason: this.closedVoidReason }
          this.moc.closedVoidUndo = this.closedVoidUndo

          const data = this.moc
          this.$refs.loadingDialog.show()
          MOCService.save(data, AdvanceType.CLOSEVOID)
            .then(result => {
              if (!result.success) {
                throw new Error(result.message)
              }
              this.closedVoidUndoDialog = false
              this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_ClosedVoidSaved') })
            })
            .catch(e => {
              this.$refs.loadingDialog.error({ metadata: 'submitClosedVoidUndo', error: e, message: this.$t('Error_CloseVoid') })
            })
            .finally(() => {
              this.isSaving = false
            })
        }
      }
    }
  }
}
</script>

<style scoped></style>
